import BitmovinPlayer from './BitmovinPlayer';

export default BitmovinPlayer;
